var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.headersLoaded)?_c('v-col',{attrs:{"cols":"12","lg":"6"}},[_c('div',{staticClass:"mb-5"},[_c('PendingInvoices',{attrs:{"data":_vm.pendingInvoicesData,"headers":_vm.headersPendingInvoices,"isLoading":_vm.dataLoading}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }